import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { GenericIdName } from '../models/common-search-filters.model';
import { CustomerSelectItem } from '../../modules/setup-equipment/setup-equipment.model';
import { Response } from '@angular/http';

@Injectable()
export class CommonFiltersService {
  private readonly CUSTOMER_LIST = 'api/Customer/GetCustomers';
  private readonly MODELS = 'api/SetupModel/GetModels';
  private readonly JobSites = 'api/JobSite/GetJobsites';
  private readonly CompartTypes = 'api/Component/GetCompartTypes';
  private readonly ActionTypes = 'api/Action/GetAvailaleActionsForCompart';
  private readonly Positions = 'api/UCSystem/GetTemplateForModelAndCompartType';

  constructor(private _http: HttpClient) { }

  public getCustomerList(): Observable<CustomerSelectItem[]> {
    return this._http.get<CustomerSelectItem[]>(this.CUSTOMER_LIST).pipe(catchError(this.handleError));
  }

  public getJobsiteList(CustomerId: number): Observable<GenericIdName[]> {
    let options = {
      params: new HttpParams().set('CustomerId', CustomerId.toString())
    };
    return this._http.get<GenericIdName[]>(this.JobSites, options).pipe(catchError(this.handleError));
  }

  public getModelList(): Observable<GenericIdName[]> {
    return this._http.get<GenericIdName[]>(this.MODELS).pipe(catchError(this.handleError));
  }

  public getCompartTypeList(ModelId: number): Observable<GenericIdName[]> {
    let options = {
      params: new HttpParams().set('ModelId', ModelId.toString())
    };
    return this._http.get<GenericIdName[]>(this.CompartTypes, options).pipe(catchError(this.handleError));
  }

  public getPositionList(ModelId: number, CompartTypeId: number): Observable<GenericIdName[]> {
    //let params: HttpParams = new HttpParams();
    //params.set('ModelId', ModelId.toString());
    //params.set('CompartTypeId', CompartTypeId.toString());
    //return this._http.get(this.Positions, { params: params }).pipe(catchError(this.handleError));
    return this._http.get<GenericIdName[]>(this.Positions + "?ModelId=" + ModelId.toString() + "&CompartTypeId=" + CompartTypeId.toString(),).pipe(catchError(this.handleError));
  }

  public getActionTypeList(CompartTypeId: number): Observable<GenericIdName[]> {
    let options = {
      params: new HttpParams().set('CompartTypeId', CompartTypeId.toString())
    };
    return this._http.get<GenericIdName[]>(this.ActionTypes, options).pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }



}
